/**
 * Enhance mobile variant dropdown experience
 */
document.addEventListener('DOMContentLoaded', function() {
  // Create backdrop element for mobile dropdowns
  const backdrop = document.createElement('div');
  backdrop.className = 'variant-dropdown-backdrop';
  document.body.appendChild(backdrop);

  // Find all variant dropdown filters
  const dropdownFilters = document.querySelectorAll('.variant-dropdown-filter');
  
  dropdownFilters.forEach(filter => {
    const toggle = filter.querySelector('.variant-dropdown-toggle');
    const dropdownList = filter.querySelector('.variant-dropdown-list');
    const filterContainer = filter.querySelector('.variant-filter-container');
    
    if (!toggle || !dropdownList) return;
    
    // Enhance open/close behavior on mobile
    toggle.addEventListener('click', function(e) {
      if (window.innerWidth <= 767) {
        e.preventDefault();
        
        // Close any other open dropdowns first
        closeAllDropdowns();
        
        // Force media gallery to a lower z-index than dropdown
        document.querySelectorAll('.media-gallery, .product__media, .cloudimage-360, .product-single__media-group, .product__media-list, .product-gallery')
          .forEach(el => {
            el.style.setProperty('z-index', '1', 'important');
          });
        
        // Open this dropdown
        filter.classList.add('active');
        dropdownList.classList.add('active');
        backdrop.classList.add('active');
        document.body.classList.add('dropdown-active');
        
        
        // Focus the search input if present
        const searchInput = filter.querySelector('.variant-filter-input');
        if (searchInput) {
          setTimeout(() => {
            searchInput.focus();
          }, 100);
        }
      }
    });
    
    // Close dropdown when clicking on backdrop
    backdrop.addEventListener('click', function() {
      closeAllDropdowns();
    });
    
    // Handle clicks anywhere in the document when dropdown is active
    document.addEventListener('click', function(e) {
      // If dropdown is active and click is outside dropdown
      const activeDropdowns = document.querySelectorAll('.variant-dropdown-list.active');
      if (activeDropdowns.length > 0) {
        let clickedInside = false;
        activeDropdowns.forEach(dropdown => {
          if (dropdown.contains(e.target) || e.target.closest('.variant-dropdown-filter')) {
            clickedInside = true;
          }
        });
        
        if (!clickedInside && !e.target.closest('.variant-dropdown-toggle')) {
          closeAllDropdowns();
        }
      }
    });
    
    // Close button functionality (the X in the filter container)
    if (filterContainer) {
      filterContainer.addEventListener('click', function(e) {
        // Check if clicking the X button (using approximate position)
        if (e.target === this && e.offsetX > (this.offsetWidth - 50)) {
          closeAllDropdowns();
        }
      });
    }
    
    // Handle "Done" button click (the ::after pseudo-element)
    dropdownList.addEventListener('click', function(e) {
      // Check if clicking in the bottom area where the "Done" button is
      const rect = this.getBoundingClientRect();
      const clickY = e.clientY;
      
      // If click is in the bottom 50px of the dropdown (where "Done" button is)
      if (clickY > (rect.bottom - 50) && clickY <= rect.bottom) {
        closeAllDropdowns();
      }
    });
    
    // Close dropdown when an option is selected
    const dropdownItems = dropdownList.querySelectorAll('.variant-dropdown-item label');
    dropdownItems.forEach(item => {
      item.addEventListener('click', function() {
        if (window.innerWidth <= 767) {
          setTimeout(() => {
            closeAllDropdowns();
          }, 150);
        }
      });
    });
  });
  
  // Function to close all active dropdowns
  function closeAllDropdowns() {
    document.querySelectorAll('.variant-dropdown-filter.active').forEach(filter => {
      filter.classList.remove('active');
    });
    document.querySelectorAll('.variant-dropdown-list.active').forEach(list => {
      list.classList.remove('active');
      list.style.zIndex = '';
    });
    backdrop.classList.remove('active');
    document.body.classList.remove('dropdown-active');
    
    // Reset any z-index changes
    document.querySelectorAll('.media-gallery, .product__media, .cloudimage-360, .product-single__media-group, .product__media-list, .product-gallery')
      .forEach(el => {
        el.style.zIndex = '';
      });
  }
  
  // Close dropdowns on ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeAllDropdowns();
    }
  });
  
  // Prevent body scrolling when dropdown is open
  document.addEventListener('touchmove', function(e) {
    if (document.body.classList.contains('dropdown-active')) {
      // Only allow scrolling within the dropdown items
      const dropdown = document.querySelector('.variant-dropdown-items');
      if (dropdown && !dropdown.contains(e.target)) {
        e.preventDefault();
      }
    }
  }, { passive: false });
}); 